export default __webpack_public_path__ + "static/media/bosch_ui_icon.ed986a21.woff2";